(function () {
  function getSelectedSizes() {
    const params = new URLSearchParams(window.location.search);
    const sizes = [];
    params.forEach((value, key) => {
      if (key === 'filter.v.option.rozmiar') {
        sizes.push(value.toLowerCase().replace('mm', '').trim());
      }
    });
    return sizes;
  }

  function formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function updatePrices() {
    const selectedSizes = getSelectedSizes();
    if (selectedSizes.length === 0) return;

    document.querySelectorAll('product-card').forEach(card => {
      const priceEl = card.querySelector('.price');
      const variantData = card.getAttribute('data-variants');
      if (!variantData) return;

      try {
        const variants = JSON.parse(variantData);
        const matchingVariants = variants.filter(v => {
          const sizeOption = (v.option1 || v.option2 || v.option3 || '')
            .toLowerCase().replace('mm', '').trim();
          return selectedSizes.includes(sizeOption);
        });

        if (matchingVariants.length === 0) return;

        // Aktualizacja ceny
        if (priceEl) {
          const prices = matchingVariants.map(v => v.price);
          const minPrice = Math.min(...prices);
          const maxPrice = Math.max(...prices);

          priceEl.textContent = minPrice === maxPrice
            ? formatPrice(minPrice)
            : formatPrice(minPrice) + ' - ' + formatPrice(maxPrice);
        }

        // Aktualizacja tytułu
        const titleEl = card.querySelector('p:not(.price)');
        if (titleEl) {
          const originalTitle = titleEl.textContent.trim();
          const sizeLabel = selectedSizes.length > 1
            ? selectedSizes.map(s => s + 'mm').join(' & ')
            : selectedSizes[0] + 'mm';
          const newTitle = originalTitle.replace(/\d+[-–]\d+mm/g, sizeLabel);
          if (newTitle !== originalTitle) {
            titleEl.textContent = newTitle;
          }
        }

      } catch (e) {}
    });
  }

  document.addEventListener('DOMContentLoaded', updatePrices);

  let lastUrl = location.href;
  new MutationObserver(() => {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      setTimeout(updatePrices, 500);
    }
  }).observe(document, { subtree: true, childList: true });

  new MutationObserver(() => {
    setTimeout(updatePrices, 300);
  }).observe(
    document.querySelector('product-grid, .product-grid, main') || document.body,
    { childList: true, subtree: false }
  );

})();
